import {select} from './tabs-core.js';
import {getDropdown} from './tabs-limit.js';

/**
 * Application des recommandations présentent ici : https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
 */
/**
 * Initialise les événements des boutons des onglets.
 * @param {HTMLElement} tabs les onglets
 * @param {HTMLButtonElement[]} tabButtons les boutons des onglets
 * @return {undefined}
 */
export function initEventsButton(tabs, tabButtons) {
  tabs.addEventListener('keyup', handleTabsKeyup(tabs), true);
  for (const currentTab of tabButtons) {
    currentTab.addEventListener('focus', handleClickHandler, true);
  }
}

/**
 * Fonction permettant de gérer les événements de type 'focus' sur les onglets.
 * @param {Event} event l'événement créé par le click.
 * @return {undefined}
 */
function handleClickHandler(event) {
  event.preventDefault();
  select(event.currentTarget);
}

/**
 * Active l'onglet ou le dropdown.
 * @param {HTMLButtonElement} tab l'onglet à activer
 */
function focusTab(tab) {
  tab?.focus();
}

/**
 * Active l'onglet précédent.
 * @param {Number} currentTabIndex index de l'onglet courant
 * @param {HTMLButtonElement[]} tabs tableau des onglets
 */
function focusPreviousTab({currentTabIndex, tabs}) {
  if (currentTabIndex > 0) {
    focusTab(tabs[currentTabIndex - 1]);
  }
}

/**
 * Active l'onglet suivant.
 * @param {Number} currentTabIndex index de l'onglet courant
 * @param {HTMLButtonElement[]} tabs tableau des onglets
 */
function focusNextTab({currentTabIndex, tabs}) {
  if (currentTabIndex !== -1 && currentTabIndex < tabs.length - 1) {
    focusTab(tabs[currentTabIndex + 1]);
  }
}

/**
 * Active le premier onglet.
 * @param {HTMLElement[]} tabs tableau des onglets
 */
function focusFirstTab({tabs}) {
  focusTab(tabs[0]);
}

/**
 * Active le dernier onglet.
 * @param {HTMLElement[]} tabs tableau des onglets
 */
function focusLastTab({tabs}) {
  focusTab(tabs[tabs.length - 1]);
}

/**
 * Fabrique pour la gestion des événements des onglets.
 * @param {HTMLElement} tabs les onglets
 * @return {EventListener} le gestionnaire
 */
function handleTabsKeyup(tabs) {
  /**
   * Fonction permettant de gérer les événements de type 'click' sur les onglets.
   * @param {Event} event l'événement créé par le click.
   * @returns {void}
   */
  return function tabsKeyupHandler(event) {
    if (!event.target.classList.contains('js-tabs__button')) {
      return;
    }
    if (event.target.closest(`[data-key]`).dataset.key !== tabs.dataset.key) {
      return;
    }
    const tabButtonsList = Array.from(tabs.querySelectorAll(`[data-scope="${tabs.dataset.key}"] > .js-tabs__button--focusable`));
    const dropdown = getDropdown(tabs);
    if (dropdown) {
      tabButtonsList.push(dropdown);
    }
    const currentTabIndex = tabButtonsList.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    const keysAction = {
      ArrowLeft: focusPreviousTab,
      ArrowRight: focusNextTab,
      Home: focusFirstTab,
      End: focusLastTab
    };
    if (Object.hasOwn(keysAction, event.key)) {
      keysAction[event.key]({currentTabIndex, tabs: tabButtonsList});
    }
  };
}

